import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface CategoryChangeWarningProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  currentCategory: string;
  newCategory: string;
  projectNumber: string;
  onConfirm: () => void;
}

export function CategoryChangeWarning({
  open,
  onOpenChange,
  currentCategory,
  newCategory,
  projectNumber,
  onConfirm,
}: CategoryChangeWarningProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Change Category?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3">
              <p>
                You are changing this project's category from{' '}
                <strong>{currentCategory}</strong> to <strong>{newCategory}</strong>.
              </p>
              <p>
                The project number <strong>{projectNumber}</strong> will remain unchanged.
                Project numbers are assigned when the project is created and cannot be
                changed.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>Change Category</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
